/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
export function getYouTubeId(url = '') {
  if (!url) {
    return '';
  }

  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes('youtu.be')) {
      return parsed.pathname.replace('/', '');
    }

    if (parsed.searchParams.get('v')) {
      return parsed.searchParams.get('v');
    }

    const embedMatch = parsed.pathname.match(/\/(?:embed|shorts)\/([^/?]+)/);
    return embedMatch ? embedMatch[1] : '';
  } catch (error) {
    return '';
  }
}
